var React = require('react');

function Users (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2","key":0}),React.createElement("circle",{"cx":"9","cy":"7","r":"4","key":1}),React.createElement("path",{"d":"M23 21v-2a4 4 0 0 0-3-3.87","key":2}),React.createElement("path",{"d":"M16 3.13a4 4 0 0 1 0 7.75","key":3})]);
}

Users.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24","fill":"none","stroke":"currentColor","strokeWidth":"2","strokeLinecap":"round","strokeLinejoin":"round","className":"feather feather-x"};

module.exports = Users;

Users.default = Users;
